// libraries
import React from "react";

// components
import { IntegrationsSections } from "../web-settings";

import { SlackSettings } from "@components/slack-settings";

// assets
import { SlackLogo } from "@clockwise/web-commons/src/components/svgs/SlackLogo";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Slack Settings
// ~-~-~-~-~-~-~-
interface SlackIntegrationProps {
  org: any;
  refetch: () => void;
}

const useStyles = makeStyles({
  h3: {
    display: "flex",
    alignItems: "center",
  },
  slackLogo: {
    marginRight: 7,
  },
});

export const SlackIntegration = (props: SlackIntegrationProps) => {
  const classes = useStyles();

  return (
    <div cw-id={`web-settings-${IntegrationsSections.Slack}`}>
      <Typography variant="h3" className={`cw-mb-4 ${classes.h3}`}>
        <SlackLogo className={classes.slackLogo} size={22} />
        Slack
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Clockwise Slack app helps you effortlessly communicate whereabouts, avoid disruptions, and
        prepare for work days. It can automatically update your Slack status, turn on Do Not Disturb
        when you're in meetings and/or Focus Time, updates you with Daily Forecast and any Autopilot
        meeting moves.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <SlackSettings org={props.org} refetch={props.refetch} hideDescription />
    </div>
  );
};
